/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description BuildingAmenity
 */

export enum BuildingAmenity {
  KNOWN = 0,
  ONSITE_MANAGEMENT = 1,
  CONCIERGE_SERVICE = 2,
  FITNESS_CENTER = 3,
  ON_SITE_LAUNDRY = 4,
  PACKAGE_SERVICE = 5,
  RESIDENTS_LOUNGE = 6,
  DRY_CLEANING_SERVICE = 7,
  GARAGE_PARKING = 8,
  SWIMMING_POOL = 9,
  STORAGE = 10,
  BUSINESS_CENTER = 11,
  DOOR_PERSON = 12,
  ROOF_DECK = 13,
  OUTDOOR_SPACE = 14,
  CONTROLLED_ACCESS = 15,
  WHEELCHAIR_ACCESSIBLE = 16,
  ELEVATOR = 17,
  /** LEED Certification Levels */
  LEED_CERTIFIED = 18,
  LEED_SILVER = 19,
  LEED_GOLD = 20,
  LEED_PLATINUM = 21,
  EV_CHARGING = 22,
}

Object.defineProperty(BuildingAmenity, '__ENUM_NAME', {
  value: 'BuildingAmenity',
  writable: false,
  configurable: false,
  enumerable: false,
})
